import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import { Modal } from 'react-bootstrap';
import moment from 'moment';
import { modalDidMount, modalWillUnmount } from './ModalFixMixin';

import AutoUserInput from './AutoUserInput';

import floatingTaskActions from '../actions/floatingTaskActionCreators';

class NewFloatingTaskWidget extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            name: this.props.name,
            description: this.props.description,
            descriptionIsEmpty: true,
            nameIsEmpty: true,
            showModal: true
        };
    }

    // LIFECYCLE METHODS

    componentDidMount = () => {
        modalDidMount();
        ReactDOM.findDOMNode(this.refs.nameInput).focus();
    }

    componentWillUnmount = () => { modalWillUnmount(); }

    // EVENT HANDLERS

    handleCancel = () => { this.props.onRequestHide(); }

    handleDescriptionChange = (event) => {
        this.setState({
            description: event.target.value,
            descriptionIsEmpty: event.target.value.length === 0
        });
    }

    handleKeyPress = (keyEvent) => {
        if (keyEvent.key === "Enter" && !keyEvent.shiftKey) {
            keyEvent.preventDefault();
            this.handleSave();
        }

        keyEvent.stopPropagation();
    }

    handleKeyUp = (keyEvent) => {
        if (keyEvent.key === "Escape") this.handleCancel();

        keyEvent.stopPropagation();
    }

    handleNameChange = (event) => {
        this.setState({
            name: event.target.value,
            nameIsEmpty: event.target.value.length === 0
        });
    }

    handleRefocus = (event) => { ReactDOM.findDOMNode(this.refs.nameInput).focus(); }

    handleSave = () => {
        if (this.state.nameIsEmpty || this.state.descriptionIsEmpty || !this.props.selectedUser) return;

        let floatingTask = {
            name: this.state.name,
            managerID: this.props.selectedUser ? this.props.selectedUser.id : null,
            managerName: this.props.selectedUser ? this.props.selectedUser.givenName + " " + this.props.selectedUser.surname : null,
            description: this.state.description,
            createdAt: moment().format("YYYY-MM-DD[T]H:mm:ss"),
            deletable: true
        };

        this.props.dispatch(floatingTaskActions.create(floatingTask));
        this.props.onRequestHide();
    }

    // RENDER METHOD

    render = () => {
        return   (
            <Modal show={this.state.showModal} onKeyPress={this.handleKeyPress} onKeyUp={this.handleKeyUp} className="modal fade" id="myModal" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
            <div className="modal-dialog new-floating">
                <div className="modal-content">
                    <div className="modal-header">
                        <button style={{marginTop : "-20px", marginRight : "-5px"}} onClick={this.handleCancel} type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">×</span>
                        </button>
                        <h4 className="modal-title" id="myModalLabel">New Floating Task</h4>
                    </div>
                    <div className="modal-body">
                        <form>
                            <div className={this.state.nameIsEmpty ? "has-error" : ""}>
                                <input ref="nameInput" type="text" value={this.state.name} onChange={this.handleNameChange} className="form-control" placeholder="Task Name"/>
                            </div>
                            <AutoUserInput
                                disableTab
                                forceInitialPopup={false}
                                displayNoSelectionError={!this.props.selectedUser ? "has-error" : ""}
                                onlyTask
                                keepAfterClick={true}
                                placeholder="Responsible PM"
                                users={this.props.pmUsers}
                                />
                            <textarea className="form-control" maxLength="1024" rows="3" style={{resize : "vertical", "border-color" : this.state.descriptionIsEmpty ? "#a94442" : ""}} value={this.state.description} onChange={this.handleDescriptionChange} placeholder="Description"></textarea>
                        </form>
                    </div>
                    <div className="modal-footer" >
                        <button title="Create floating task" type="button" ref="saveButton" onClick={this.handleSave} className="btn btn-default btn-large">Save</button>
                        <button title="Cancel and close dialog" type="button"  data-dismiss="modal" onBlur={this.handleRefocus} onClick={this.handleCancel} className="btn btn-default btn-discrete" >Close</button>
                    </div>
                </div>
            </div>
        </Modal>
        );
    }
}

NewFloatingTaskWidget.propTypes = {
    description: PropTypes.string,
    dispatch: PropTypes.func,
    name: PropTypes.string,
    onRequestHide: PropTypes.func,
    pmUsers: PropTypes.array
};

NewFloatingTaskWidget.defaultProps = {
    name: '',
    pm: '',
    description: '',
    pmUsers: []
};

const mapStateToProps = (state) => {
    return {
        selectedUser: state.users.selectedUser
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NewFloatingTaskWidget);



/** WEBPACK FOOTER **
 ** ./src/app/components/NewFloatingTaskWidget.js
 **/